module.exports = __webpack_public_path__ + "static/media/ehl-1.48b7e9e8.svg";